/**
 * Partner Benefits HTTP Repository - /api/v1/partner-benefits
 */

import { httpClient } from '@shared/infrastructure/http/base.client';
import type {
  PartnerBenefitResponse,
  PartnerBenefitsListParams,
} from '../../../application/dto/PartnerBenefitDTO';

const BASE = '/partner-benefits';

export const partnerBenefitsApi = {
  list(params?: PartnerBenefitsListParams): Promise<PartnerBenefitResponse[]> {
    return httpClient.get<PartnerBenefitResponse[]>(BASE, { params });
  },

  get(id: string): Promise<PartnerBenefitResponse> {
    return httpClient.get<PartnerBenefitResponse>(`${BASE}/${id}`);
  },
};
